import { createSlice } from '@reduxjs/toolkit';

const app = createSlice({
  name: 'app',
  initialState: {
    bookADemoFormOpen: false,
    feedbackDialogOpen: false,
    contactSupportFormOpen: false,
    configuratorRequestFormOpen: false,
    uploadedFiles: {},
    completedFiles: [],
    showPopupBlockModal: false,
    useCacheInAPI: localStorage.getItem("CACHE_TIMESTAMP") ? JSON.parse(localStorage.getItem("CACHE_TIMESTAMP")) : Date.now(),
  },
  reducers: {
    setBookADemoFormOpen: (state, { payload }) => {
      state.bookADemoFormOpen = payload;
    },
    setFeedbackDialogOpen: (state, { payload }) => {
      state.feedbackDialogOpen = payload;
    },
    setContactSupportFormOpen: (state, { payload }) => {
      state.contactSupportFormOpen = payload;
    },
    setConfiguratorRequestFormOpen: (state, { payload }) => {
      state.configuratorRequestFormOpen = payload;
    },
    setUploadedFiles: (state, { payload }) => {
      state.uploadedFiles.files = payload;
    },
    addFiles: (state, { payload }) => {
      state.uploadedFiles = { ...state.uploadedFiles, ...payload };
    },
    updateFile: (state, { payload }) => {
      if (state.uploadedFiles?.files?.[payload?.id]) {
        state.uploadedFiles.files[payload?.id] = payload;
      }
    },
    setCompletedFiles: (state, { payload }) => {
      state.completedFiles = [...state.completedFiles, payload];
    },
    setResetFiles: (state) => {
      state.uploadedFiles = {};
      state.completedFiles = [];
    },
    setShowPopupBlockModal: (state, { payload }) => {
      state.showPopupBlockModal = payload;
    },
    setUseCacheInAPI: (state, { payload }) => {
      state.useCacheInAPI = payload;
      localStorage.setItem("CACHE_TIMESTAMP", payload);
    },
  },
});

export const {
  setBookADemoFormOpen,
  setFeedbackDialogOpen,
  setContactSupportFormOpen,
  setConfiguratorRequestFormOpen,
  setUploadedFiles,
  addFiles,
  updateFile,
  setResetFiles,
  setCompletedFiles,
  setShowPopupBlockModal,
  setUseCacheInAPI,
} = app.actions;
export const appSelector = (state) => state.app;
export const appReducer = app.reducer;
export default appReducer;

export const selectBookADemoFormOpen = (state) => state.app.bookADemoFormOpen;
export const selectFeedbackDialogOpen = (state) => state.app.feedbackDialogOpen;
export const selectContactSupportFormOpen = (state) => state.app.contactSupportFormOpen;
export const selectConfiguratorRequestFormOpen = (state) => state.app.configuratorRequestFormOpen;
export const selectCompletedFiles = (state) => state.app.completedFiles;
export const selectUploadCompleted = (state) => {
  if (
    Object.keys(state.app.uploadedFiles?.files || {})?.length === 0 ||
    state.app.completedFiles?.length === 0
  )
    return false;
  return state.app.completedFiles.length === Object.keys(state.app.uploadedFiles?.files)?.length;
};

export const selectUploadedFiles = (state) => {
  return Object.fromEntries(
    Object.entries(state.app.uploadedFiles).filter(([key]) => key !== 'undefined')
  );
};
export const selectShowPopupBlockModal = (state) => state.app.showPopupBlockModal;
export const selectIsCacheUsedInAPI = (state) => state.app.useCacheInAPI;